package com.mshopsas.enterprise.aiw.scan.data

data class Parameters(
    val storeUuid: String?,
    val identifier: String?,
)

expect fun getParameters(): Parameters
